import { useQueryGetProfile } from '@cash-web/shared-data-access-api/react-query/useQueryGetProfile'

export const useProfile = (options?: Omit<Parameters<typeof useQueryGetProfile>[0], 'refetchInterval' | 'retry'>) =>
  useQueryGetProfile({
    ...options,
    queryOptions: {
      ...options?.queryOptions,
      // We do not want to continually refresh this to reduce the load on downstream services
      // the value will still be refetched on window focus to handle the case where a customer
      // logs out on another tab
      refetchInterval: false,
      retry: (number, error) => {
        return error.response?.status !== 401
      },
    },
  })

useProfile.rootQueryKey = useQueryGetProfile.rootQueryKey
useProfile.asQueryConfig = useQueryGetProfile.asQueryConfig
